const ComponentsLookup = {
  "local-partnership-page": "LocalPartnershipPageD85e97da2c2944c8Aed80dedd24f88e8",
  "default-header-top": "DefaultHeaderTop24ec4652D49c4a82Bc89787abeecd5e1",
  "secondary-marketing-header": "SecondaryMarketingHeaderAbeb3bbf3790485c9a49146f8ef4e521",
  "about-us-page": "AboutUsPageB8b9bef935664bc69e4eBb11f70aa588",
  "public-events-page": "PublicEventsPage77ee98ee38524f159c0308335faf554b",
  "join-us-page": "JoinUsPageF56cb81a742a45f186858f9f64d174d9",
  "application-pages": "ApplicationPages0ed336a0Cebe4984Bdbf45bd5ca0af28",
  "public-contact-page": "PublicContactPage9b1ae4c4E9ad4b19968c68e997e5436a",
  "public-faq-page": "PublicFaqPageCea9d9ef69ee49718cabB2f3d0d42dca",
  "home-page": "HomePage4192a8edA2cd4722A59eD974e90caa4e",
  "default-footer": "DefaultFooterD381f58e36d84e3b9b87E52cadfa7213",
  "secondary-page": "SecondaryPage4b047484Dc1948a2Bf01C1c5a44447b1",
  "secondary-marketing-hero": "SecondaryMarketingHeroBb1388ebCab7426aB006689d73d56336"
}

export default ComponentsLookup;